<template>
	<div class="home">
		<!-- <login v-if="!isLoggedIn" /> -->
		<homepage v-if="isShowLanding" />
		<dashboard v-if="isLoggedIn" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';
// import Login from '@/views/Login.vue';
// import Dashboard from '@/views/Dashboard.vue';

// const Login = () => ({
// 	component: import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
// 	loading: Loader,
// });

const Homepage = () => ({
	component: import(/* webpackChunkName: "landing" */ '@/components/homepages/Homepage.vue'),
	loading: Loader,
});

const Dashboard = () => ({
	component: import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
	loading: Loader,
});

export default {
	name: 'Home',
	components: {
		// Login,
		Homepage,
		Dashboard,
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
			isUserCan: 'isUserCan',
			isDropshipper: 'isDropshipper',
		}),
		isShowLanding() {
			let isShow = false;

			if (!this.isLoggedIn) {
				isShow = true;
			} else if (this.isLoggedIn && this.isDropshipper) {
				isShow = true;
			}

			return isShow;
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.checkMarketplaceIntegrate();
		},
		checkMarketplaceIntegrate() {
			// eslint-disable-next-line camelcase
			const { code, store_label } = this.$route.query || {};
			// eslint-disable-next-line camelcase
			if (code && store_label) {
				this.$router.push({
					path: '/settings/marketplace/loader-integrate',
					query: this.$route.query,
				});
			}
		},
	},
};
</script>
